<template>
  <div>
    <WZNukeOverlay
      v-if="params"
      :overlay="params"
      duration="10000"
    />
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import WZNukeOverlay from '../components/WZNukeOverlay.vue';

export default {
  name: 'NukeOverlay',
  components: {
    WZNukeOverlay,
  },

  data() {
    return {
      params: null,
    };
  },

  created() {
    this.init();
    this.timer = setInterval(this.init, 5000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    init() {
      const { uid } = this.$route.params;
      axios.get(`https://api.wzhub.gg/api/nuke/${uid}`).then((response) => {
        if (response.data.success) {
          this.params = response.data.nukes.overlay;
        } else {
          clearInterval(this.timer);
          this.params = null;
        }
      });
    },
  },
};
</script>
